import { Lead } from '../../components/typography/Heading';
import Image from '../../components/image/Image';
import { ActionButton } from '@sb1/ffe-buttons-react';
import styles from './bosseAfterGiveTVA.module.less';
import RoundedButtonLinkSecondary from '../../components/button/rounded-button-link-secondary/RoundedButtonLinkSecondary';
import { Link } from 'react-router';

const BosseAfterGiveTVA = () => {
    return (
        <div className={styles.container}>
            <Image
                className={styles.headerImage}
                src="campaign/tva2026/coverbilde.webp"
                alt="Del spleisen så hjelper du den å samle inn mer"
            />
            <Lead className={styles.lead}>
                <p>Du kan starte din egen digitale bøsse til TV&#8209;aksjonen!</p>
            </Lead>

            <div className={styles.buttonContainer}>
                <ActionButton as={Link} to={'/project/select/template?provider=tva'}>
                    Start en digital bøsse
                </ActionButton>
            </div>

            <Lead className={styles.lead}>
                <p>Vi trenger fortsatt bøssebærere til søndag 18. oktober</p>
            </Lead>

            <div className={styles.buttonContainer}>
                <RoundedButtonLinkSecondary
                    category={'support'}
                    action={'to-tva'}
                    properties={{ action: 'click' }}
                    to={'https://tvaksjonen.no'}
                >
                    Meld deg som bøssebærer
                </RoundedButtonLinkSecondary>
            </div>
        </div>
    );
};

export default BosseAfterGiveTVA;
